import { IsNotEmpty, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { FingerprintDto } from './referral-fingerprint.dto';

export class AuthWithApple {
	@IsString()
	@IsNotEmpty()
	identityToken: string;

	@IsString()
	firstName?: string;

	@IsString()
	lastName?: string;

	@IsOptional()
	@IsString()
	referralCode?: string;

	@IsOptional()
	@IsObject()
	@ValidateNested()
	@Type(() => FingerprintDto)
	fingerprint?: FingerprintDto;

	@IsOptional()
	@IsString()
	ipAddress?: string;

	@IsOptional()
	@IsString()
	college?: string;

	@IsOptional()
	@IsString()
	utmSource?: string;
}

export class AppleUserDto {
	appleId: string;
	appleEmail: string;
	firstName: string;
	lastName: string;
	isAppleEmailPrivate: boolean;
	referralCode?: string;
}
